import { makeAutoObservable } from "mobx";
import { LoaderShelf } from "../LoaderShelf";

export class FetchShelf<ResponseType> {
	public loader = new LoaderShelf();

	constructor(
		public fetcher: () => Promise<ResponseType>,
		public onSuccess?: (response: ResponseType) => Promise<void> | void,
		public onError?: (err: never) => Promise<void> | void,
	) {
		makeAutoObservable(this);
	}

	public fetch = async (): Promise<void> => {
		if (this.loader.isLoading) {
			return;
		}

		try {
			this.loader.start();
			const response = await this.fetcher();
			if (this.onSuccess) {
				this.onSuccess(response);
			}
		} catch (err) {
			const e = err as never;
			if (this.onError) {
				this.onError(e);
			}
			window.console.error(err);
		} finally {
			this.loader.end();
		}
	};
}
